import Modal from "@via/components/modal.tsx";
import { ButtonColor } from "@via/utils/constants.tsx";
import { type FC } from "react";
import { useDeleteCustomInstruction } from "@via/pages/account/profile/integration-tokens/custom-instructions/custom-instructions.api";
import { AIInstruction } from "common";

type DeleteCustomInstructionModalProps = {
  customInstruction: AIInstruction | null;
  setCustomInstructionToBeDeleted: (
    customInstruction: AIInstruction | null
  ) => void;
};

const DeleteCustomInstructionModal: FC<DeleteCustomInstructionModalProps> = ({
  customInstruction,
  setCustomInstructionToBeDeleted,
}) => {
  const {
    mutateAsync: deleteCustomInstruction,
    isPending: isDeleteCustomInstructionLoading,
  } = useDeleteCustomInstruction();

  const handleDeleteCustomInstruction = async (
    id: string
  ): Promise<void | boolean> => {
    // Returning false keeps the dialog open. Resolving closes it through Modal's
    // setOpen, which is what clears the row being deleted, so there is one close
    // path rather than a success effect racing the dialog.
    if (!id) return false;
    await deleteCustomInstruction(id);
  };

  return (
    <Modal
      open={!!customInstruction}
      setOpen={() => {
        setCustomInstructionToBeDeleted(null);
      }}
      title="Delete Custom Instruction"
      confirmText="Delete"
      confirmButtonColor={ButtonColor.Red}
      isConfirmLoading={isDeleteCustomInstructionLoading}
      onConfirm={() =>
        handleDeleteCustomInstruction(customInstruction!.id.toString())
      }>
      <div className="flex flex-col py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          Are you sure you want to delete instruction{" "}
          <span className="font-semibold">{customInstruction?.name}</span>?
        </p>
      </div>
    </Modal>
  );
};

export default DeleteCustomInstructionModal;
